import { Modal, ModalBody } from "reactstrap";
import close from "../../../assets/images/close.png";
import styles from "./index.module.css";

export const DocumentEnum = {
  2: "Pan Kyc Match",
  5: "Ckyc Kyc Match",
  6: "DigiLocker Kyc Match",
  3: "Cibil Kyc Match",
};

export default function ShowDetails({
  open,
  userVerificationData,
  setShowVerificationDetails,
}) {
  return (
    <Modal
      style={{
        top: "5%",
        width: "400px",
      }}
      isOpen={open}
    >
      <div
        style={{
          borderTopLeftRadius: "8px",
          borderTopRightRadius: "8px",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center !important",
          backgroundColor: "#E9E9E9",
          padding: "12px 12px 0px 12px",
        }}
      >
        <p className={styles.title}>
        {userVerificationData
            ? `${DocumentEnum[userVerificationData?.document]} Details`
            : "Verification Details"}
        </p>
        <img
          onClick={() => setShowVerificationDetails(false)}
          src={close}
          alt="close"
          className={styles.closeImage}
        />
      </div>

      <ModalBody className={styles.modalBody}>
        {userVerificationData ? (
          <>
            <div className={styles.labelContainer}>
              <p className={styles.labelName}>Name Match Score</p>
              <p className={styles.labelValue}>
                {`${userVerificationData?.nameMatchScore}%`}
              </p>
            </div>

            {userVerificationData?.document === 2 && (
              <div className={styles.labelContainer}>
                <p className={styles.labelName}>Status</p>
                <p className={styles.labelValue}>
                  {userVerificationData?.status}
                </p>
              </div>
            )}

            <div className={styles.labelContainer}>
              <p className={styles.labelName}>DOB Match</p>
              <p className={styles.labelValue}>
                {userVerificationData?.dobMatch === 1
                  ? "Matched"
                  : "Not Matched"}
              </p>
            </div>

            <div className={styles.labelContainer}>
              <p className={styles.labelName}>Gender Match</p>
              <p className={styles.labelValue}>
                {userVerificationData?.genderMatch === 1
                  ? "Matched"
                  : "Not Matched"}
              </p>
            </div>
          </>
        ) : (
          <div className={styles.noData}>
            No data available
          </div>
        )}
      </ModalBody>
    </Modal>
  );
}
